// A new share page address: <this site>/share/<random id>. The backend only
// accepts exactly this shape (BE controllers/shareRules.js: CORS_ORIGIN +
// "/share/" + a lowercase UUID v4), and the id is the only thing protecting the
// share, so it comes from the browser's crypto source. (The pages used to roll
// their own from Math.random, one group short of a UUID.)
export function newShareLink() {
  return `${window.location.origin}/share/${window.crypto.randomUUID()}`;
}

// The address under which an OPEN share is looked up: origin + pathname, without the
// query or fragment a mail client may append and without a trailing slash (the saved
// link never has one). Must match the link saved at share time exactly.
export function shareLinkFromLocation(loc = window.location) {
  return `${loc.origin}${String(loc.pathname || '').replace(/\/+$/, '')}`;
}
